type MetadataValue = string | number | boolean | null | undefined;

function redactSecrets(value: string) {
  return value
    .replace(/(?:https?|s3|blob):\/\/[^\s"'<>]+/gi, "[redacted-url]")
    .replace(
      /(authorization\s*["']?\s*[:=]\s*["']?)(?:(?:bearer|oauth)\s+)?[^\s"',;&}]+/gi,
      "$1[redacted]"
    )
    .replace(
      /((?:access[_-]?token|x-amz-[\w-]+|signature|credential|token|secret)\s*["']?\s*[:=]\s*["']?)[^\s"',;&}]+/gi,
      "$1[redacted]"
    )
    .replace(/[\r\n]/g, " ")
    .slice(0, 255);
}

function sanitizeValue(key: string, value: MetadataValue) {
  if (typeof value !== "string") return value;
  const normalizedKey = key.toLowerCase();
  if (normalizedKey.includes("url")) return "[redacted-url]";
  if (/^(?:https?|s3|blob|data):/i.test(value)) return "[redacted-url]";
  if (normalizedKey.includes("filename")) return "[redacted-filename]";
  if (normalizedKey === "jobid" || normalizedKey === "transcodingjobid") {
    return "[redacted-job-reference]";
  }
  if (
    /(?:authorization|access[_-]?token|credential|signature|secret)/i.test(key)
  ) {
    return "[redacted]";
  }
  return redactSecrets(value);
}

export function sanitizeObservabilityMetadata(
  metadata?: Record<string, MetadataValue>
): Record<string, string | number | boolean> {
  if (!metadata) return {};
  return Object.fromEntries(
    Object.entries(metadata)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, sanitizeValue(key, value)])
  ) as Record<string, string | number | boolean>;
}
